import { render, staticRenderFns } from "./ListItemLabel.vue?vue&type=template&id=f6adee72"
import script from "./ListItemLabel.vue?vue&type=script&lang=js"
export * from "./ListItemLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports